<div class="ds-text-center">
  <button
    *ngIf="type === 'day' || type === 'week'"
    class="ds-button-expand ds-capitalize"
    [attr.active]="resolution === 'month' ? 'true' : null"
    (click)="resolution === 'month' ? zoomOut() : zoomIn('month')"
    #displayMonth
  ></button>
  <button
    *ngIf="type === 'day' || type === 'week' || type === 'month'"
    class="ds-button-expand"
    [attr.active]="resolution === 'year' ? 'true' : null"
    (click)="resolution === 'year' ? zoomOut() : zoomIn('year')"
    #displayYear
  ></button>
</div>
